import client from './client';

/** Fetches the customer's communication preference and on-file contact details. */
export async function fetchPreferences() {
  const response = await client.get('/api/care-portal/preferences');
  return response.data;
}

/** Updates the customer's communication preference. Returns the updated preference. */
export async function updatePreferences({ prefersEmail, prefersPhone }) {
  const response = await client.put('/api/care-portal/preferences', {
    prefersEmail,
    prefersPhone,
  });
  return response.data;
}
